module.exports = "pegasus/assets/italian-landscape-mountains-nature.png";